import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { RefreshCw } from "lucide-react";
import { toast } from "@fox1ck-org/ui/toast";
import { api } from "@/api/client";
import { Button } from "@fox1ck-org/ui";

export function SyncButton({ appName }: { appName: string }) {
  const queryClient = useQueryClient();
  const [showConfirm, setShowConfirm] = useState(false);

  const syncMutation = useMutation({
    mutationFn: (prune: boolean) => api.cluster.sync(appName, prune),
    onSuccess: () => {
      toast.success("Синхронизация запущена");
      queryClient.invalidateQueries({ queryKey: ["cluster-app", appName] });
      queryClient.invalidateQueries({ queryKey: ["cluster-app-status", appName] });
      setShowConfirm(false);
    },
    onError: (err) => toast.error(`Синхронизация не удалась: ${err.message}`),
  });

  if (showConfirm) {
    return (
      <div className="flex items-center gap-2">
        <Button size="sm" onClick={() => syncMutation.mutate(false)} disabled={syncMutation.isPending}>
          {syncMutation.isPending ? "Синхронизируем…" : "Синхронизировать"}
        </Button>
        <Button size="sm" variant="outline" className="border-yellow-500/50 text-yellow-400 hover:bg-yellow-500/10" onClick={() => syncMutation.mutate(true)} disabled={syncMutation.isPending}>
          Синхронизировать с очисткой
        </Button>
        <Button size="sm" variant="ghost" onClick={() => setShowConfirm(false)}>
          Отмена
        </Button>
      </div>
    );
  }

  return (
    <Button variant="outline" size="sm" onClick={() => setShowConfirm(true)}>
      <RefreshCw className="h-4 w-4" />
      Синхронизация
    </Button>
  );
}
